import React, { useContext } from 'react';
import { useMobile } from '../../hooks/mobile.hook';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import { PageDataContext } from '../../providers/page-data-provider';
import getStyles from './styles';

const PageHeader = (): JSX.Element => {
  const { headerText } = useContext(PageDataContext);
  const isBRRedesign = useBRRedesign();

  return (
    <h1
      className="page-header"
      data-testid="page-header"
      css={getStyles(isBRRedesign, useMobile())}
    >
      {headerText}
    </h1>
  );
};

export default PageHeader;
